<ng-container>
  <span mat-dialog-title>EDIT CREDIT OUTLETS</span>
  <div mat-dialog-content>
    <div>
      <ng-container>
        <div class="row">
          <div class="col-md-4">
            <div class="row">
              <div class="col-md-6"><h3><a href="{{data.projecturl}}" class="data-link" target="_blank">{{data.project}}</a></h3></div><div class="col-md-6"><div class="syndications-flag" (click)="toggleSyndicationsFlag()">@if (projectDetails.is_flagged) {
              <i class="material-icons">check_circle</i>
              }@if (!projectDetails.is_flagged) {
              <i class="material-icons-outlined">check_circle_outline</i>
            }</div></div>
          </div>
        </div>
      </div>
      <div class="row">
        <div class="col-md-8">
          <div class="row">
            <div class="col-md-2">
              Status:
            </div>
            <div class="col-md-4">
              <mat-form-field>
                <mat-select [formControl]="statusControl" (selectionChange)="onStatusChange($event)">
                  @for (status of data.sequenceStatuses; track status) {
                    <mat-option [value]="status">{{status.name}}</mat-option>
                  }
                </mat-select>
              </mat-form-field>
            </div>
          </div>
        </div>
      </div>
      <div>Sponsor: <a href="{{data.sponsorurl}}" class="data-link" target="_blank">{{data.sponsor}}</a></div>
      <div>Closing Date: {{data.closing_date | date: 'MM/dd/yyyy'}}</div>
      @if (!isLoaded) {
        <div class="loading-spinner"><mat-spinner diameter="30"></mat-spinner></div>
      }
      @if (isLoaded) {
        <button mat-flat-button class="add-link" (click)="showHideAddCreditOutlet()">+ Add a Credit Outlet</button>
        @if (showAddCreditOutletSection) {
          <div class="add-credit-container mat-elevation-z4" >
            <form [formGroup]="addCreditForm">
              <div class="row">
                <h5>Select Credit Type(s)</h5>
              </div>
              <div class="row">
                @for (credit of availableCredits; track credit) {
                  <div class="col-md-2">
                    <mat-checkbox [value]="credit" formControlName="{{credit.tax_level}} {{credit.tax_name}}" (change)="enableField(credit, $event)">{{credit.tax_level}} {{credit.tax_name}}</mat-checkbox>
                  </div>
                }
              </div>
              <div class="row">
                <h5>Select the Outlet Type</h5>
              </div>
              <div class="row">
                <mat-radio-group formControlName="outlet_type">
                  <mat-radio-button value="fund">Fund</mat-radio-button>
                  <mat-radio-button value="certificated">Certificated</mat-radio-button>
                </mat-radio-group>
              </div>
              <div class="row"><h5>Search for Outlet</h5></div>
              <div class="row">
                <div class="col-md-10">
                  <div class="row">
                    <mat-form-field>
                      <input matInput type="text" formControlName="outlet" name="outlet" (focus)="searchOutlets($event)" [matAutocomplete]="searchauto" >
                    </mat-form-field>
                    <mat-autocomplete #searchauto="matAutocomplete" [displayWith]="displayVal">
                      @for (val of searchResults; track val) {
                        <mat-option
                          [value]="val"
                          >
                          {{val.name ?? val.organization.name}}
                        </mat-option>
                      }
                    </mat-autocomplete>
                  </div>
                </div>
                <div class="col-md-2">
                  @if (hasCreditSelected(addCreditForm, availableCredits)) {
                    <button mat-raised-button (click)="addCredit(addCreditForm)" class="add-outlet-button">Add</button>
                  }
                </div>
              </div>
            </form>
          </div>
        }
        @for (fund of projectForms | keyvalue; track fund) {
          <div class="fund-expand-outline">
            <div class="row fund-expanded-header">
              <!--          <h4 style="font-size: 18px">{{fund.key}}</h4>-->
              <div class="col-md-3">{{fund.key}}</div>
              <div class="expanded-button" (click)="fundExpanded(fund.key)"><i class="material-icons">{{expandedFunds.has(fund.key) ? 'keyboard_arrow_up' : 'keyboard_arrow_down'}}</i></div>
            </div>
            @if (expandedFunds.has(fund.key)) {
              @for (form of fund.value; track form) {
                <form [formGroup]="form" (keydown.enter)="$event.preventDefault()" (keydown.tab)="$event.preventDefault()">
                  <div class="credit-container">
                    <div [ngClass]="headerStyle(form.value.credit_type)">
                      <div class="col-md-2">
                        <h4 style="font-size: 18px">{{form.value.credit_type}}</h4>
                        <!--                  <div class="header-text">{{form.value.credit_type}}</div>-->
                      </div>
                      <div class="col-md-1">
                        <div style="display:flex; justify-content: flex-end">
                          <button mat-mini-fab (click)="removeCreditFromFund(form, fund.key)" class="delete-button"><i class="material-icons">close</i></button>
                        </div>
                      </div>
                    </div>
                    <div class="row gutters">
                      <mat-form-field>
                        <mat-select [formControl]="form.controls.placement_status" (selectionChange)="onFieldChange(fund.key, form.controls, 'placement_status')">
                          @for (state of fundProjectStates; track state) {
                            <mat-option [value]="state.id">{{state.name}}</mat-option>
                          }
                        </mat-select>
                      </mat-form-field>
                    </div>
                    <div class="row">
                      <div class="col-md-4">
                        <div class="row" style="">
                          <mat-form-field class = "field">
                            <mat-label>Revenue Year</mat-label>
                            <input type="number" formControlName="revenue_year" name="revenue_year" matInput
                              (keyup)="onFieldChange(fund.key, form.controls, 'revenue_year')"
                              (keydown)="onFieldChange(fund.key, form.controls, 'revenue_year')"
                              (change)="onFieldChange(fund.key, form.controls, 'revenue_year')"
                              (wheel)="$event.preventDefault()"
                              >
                            @if (form.controls.revenue_year.hasError('required')) {
                              <mat-error>
                                Revenue year is required
                              </mat-error>
                            }
                          </mat-form-field>
                        </div>
                      </div>
                      <div class="col-md-4">
                        <div class="row" style="margin-left: 10px;margin-right:10px">
                          <mat-form-field class="field">
                            <mat-label>Ownership %</mat-label>
                            <input type="number" formControlName="ownership" name="ownership" step=".0001" matInput
                              (keyup)="onFieldChange(fund.key, form.controls, 'ownership')"
                              (keydown)="onFieldChange(fund.key, form.controls, 'ownership')"
                              (change)="onFieldChange(fund.key, form.controls, 'ownership')"
                              (wheel)="$event.preventDefault()"
                              >
                          </mat-form-field>
                        </div>
                      </div>
                      <!--                  <div class="col-md-3">-->
                    <!--                  </div>-->
                    <!--                  <div class="col-md-3">-->
                    <!--                    <div class="row">-->
                    <!--                      <mat-form-field class="field">-->
                    <!--                        <mat-label>Load %</mat-label>-->
                    <!--                        <input matInput formControlName="load" name="load" type="number"-->
                    <!--                               (keyup)="onFieldChange(fund.key, form.controls, 'load')"-->
                    <!--                               (keydown)="onFieldChange(fund.key, form.controls, 'load')"-->
                    <!--                               (change)="onFieldChange(fund.key, form.controls, 'load')"-->
                    <!--                               (wheel)="$event.preventDefault()"-->
                    <!--                        >-->
                  <!--                      </mat-form-field>-->
                <!--                    </div>-->
              <!--                  </div>-->
            </div>
            <div class="row align-top" style="margin-bottom: 20px">
              <div class="col-md-4">
                <div class="row" style="">
                  <mat-form-field class="field">
                    <mat-label>Investor Approval Date</mat-label>
                    <input matInput type="text" formControlName="investor_approval_date" [matDatepicker]="investorDatePicker"
                      (dateChange)="onFieldChange(fund.key, form.controls, 'investor_approval_date')"
                      (dateInput)="onFieldChange(fund.key, form.controls, 'investor_approval_date')"
                      (wheel)="$event.preventDefault()"
                      >
                    <mat-datepicker-toggle matIconPrefix [for]="investorDatePicker"></mat-datepicker-toggle>
                    <mat-datepicker #investorDatePicker></mat-datepicker>
                    <mat-hint><mat-radio-group formControlName="is_target_investor_approval" (change)="onFieldChange(fund.key, form.controls, 'is_target_investor_approval')">
                      <mat-radio-button [value]="true" style="font-size: 12px">Target</mat-radio-button>
                      <mat-radio-button [value]="false" style="font-size: 12px">Actual</mat-radio-button>
                    </mat-radio-group></mat-hint>
                  </mat-form-field>
                  @if (form.errors?.invalidInvestorDate) {
                    <mat-error style="font-size: 12px; margin-top: 8px;">Investor date cannot be after admitted date</mat-error>
                  }
                </div>
                <!--                  <mat-checkbox formControlName="is_target_investor_approval" (change)="onFieldChange(fund.key, form.controls, 'is_target_investor_approval')"><small>Target Date</small></mat-checkbox>-->
              </div>
              <div class="col-md-4">
                <div class="row" style="">
                  <div class="row" style="justify-content: center">Warehouse ?</div>
                  <div class="row">
                    <mat-radio-group formControlName="warehoused" class="form-toggles" (change)="onFieldChange(fund.key, form.controls, 'warehoused')">
                      <mat-radio-button [value]="true" class="small-radio">Yes</mat-radio-button>
                      <mat-radio-button [value]="false" class="small-radio">No</mat-radio-button>
                    </mat-radio-group>
                  </div>
                </div>
                <!--                  <mat-checkbox formControlName="warehoused" (change)="onFieldChange(fund.key, form.controls, 'warehoused')">Warehouse ?</mat-checkbox>-->
              </div>
              <div class="col-md-4">
                <div class="row" style="margin-right:10px">
                  <mat-form-field class="field">
                    <mat-label>Warehoused Days</mat-label>
                    <input matInput formControlName="projected_warehouse_days" name="projected_warehouse_days" type="number"
                      (keyup)="onFieldChange(fund.key, form.controls, 'projected_warehouse_days')"
                      (keydown)="onFieldChange(fund.key, form.controls, 'projected_warehouse_days')"
                      (change)="onFieldChange(fund.key, form.controls, 'projected_warehouse_days')"
                      (wheel)="$event.preventDefault()"
                      >
                  </mat-form-field>
                </div>
              </div>
              <!--                  <div class="col-md-3">-->
              <!--                    <div class="row">-->
              <!--                        <mat-form-field class="field">-->
              <!--                          <mat-label>UT IRR</mat-label>-->
              <!--                          <input matInput formControlName="ut_irr" name="ut_irr" type="number"-->
              <!--                                 (keyup)="onFieldChange(fund.key, form.controls, 'ut_irr')"-->
              <!--                                 (keydown)="onFieldChange(fund.key, form.controls, 'ut_irr')"-->
              <!--                                 (change)="onFieldChange(fund.key, form.controls, 'ut_irr')"-->
              <!--                                 (wheel)="$event.preventDefault()"-->
              <!--                          >-->
            <!--                        </mat-form-field>-->
          <!--                    </div>-->
        <!--                  </div>-->
      </div>
      <div class="row align-top" style="margin-bottom: 20px">
        <div class="col-md-4">
          <div class="row" style="">
            <mat-form-field class="field">
              <mat-label>Admitted Date</mat-label>
              <input matInput type="text" formControlName="admitted_date" [matDatepicker]="admissionDatePicker"
                (dateChange)="onFieldChange(fund.key, form.controls, 'admitted_date')"
                (dateInput)="onFieldChange(fund.key, form.controls, 'admitted_date')"
                (wheel)="$event.preventDefault()"
                >
              <mat-datepicker-toggle matIconPrefix [for]="admissionDatePicker"></mat-datepicker-toggle>
              <mat-datepicker #admissionDatePicker></mat-datepicker>
              <mat-hint>
                <mat-radio-group formControlName="is_target" (change)="onFieldChange(fund.key, form.controls, 'is_target')">
                  <mat-radio-button [value]="true">Target</mat-radio-button>
                  <mat-radio-button [value]="false">Actual</mat-radio-button>
                </mat-radio-group>
              </mat-hint>
            </mat-form-field>
          </div>
          <!--                  <mat-checkbox formControlName="is_target" (change)="onFieldChange(fund.key, form.controls, 'is_target')"><small>Target Date</small></mat-checkbox>-->
        </div>
        <div class="col-md-4">
          <div class="row" style="margin-left: 10px;margin-right:10px">
            <mat-form-field [floatLabel]="form.value.gross_equity==null ? 'auto' : 'always'" class="field">
              <mat-label>Gross Equity</mat-label>
              <input type="number" formControlName="estimated_gross_equity" name="estimated_gross_equity" (wheel)="$event.preventDefault()" placeholder = "{{form.value.gross_equity?.toFixed(2) }}" matInput>
              @if (form.value.estimated_gross_equity!==null) {
                <mat-hint>{{form.value.estimated_gross_equity | currency : 'USD': 'symbol': '1.2-2'}}</mat-hint>
              }
              @if (form.value.estimated_gross_equity==null) {
                <mat-hint>{{form.value.gross_equity | currency: 'USD' : 'symbol' : '1.2-2'}}</mat-hint>
              }
            </mat-form-field>
          </div>
        </div>
        <div class="col-md-4">
          <div class="row" style="margin-right:10px">
            <mat-form-field class="exit">
              <mat-label>Exit Date</mat-label>
              <input matInput type="text" formControlName="exit_date" [matDatepicker]="exitDatePicker"
                (dateChange)="onFieldChange(fund.key, form.controls, 'exit_date')"
                (dateInput)="onFieldChange(fund.key, form.controls, 'exit_date')"
                (wheel)="$event.preventDefault()"
                >
              <mat-datepicker-toggle matIconPrefix [for]="exitDatePicker"></mat-datepicker-toggle>
              <mat-datepicker #exitDatePicker></mat-datepicker>
              <mat-hint>
                <mat-radio-group formControlName="is_target_exit">
                  <mat-radio-button [value]="true">Target</mat-radio-button>
                  <mat-radio-button [value]="false">Actual</mat-radio-button>
                </mat-radio-group>
              </mat-hint>
            </mat-form-field>
          </div>
        </div>
        <div class="col-md-3"></div>
      </div>
    </div>
  </form>
}
}
</div>
}
<div class="row">
  <h4>Syndications Notes:</h4>
  <mat-form-field>
    <textarea matInput [formControl]="notesControl" type="text"></textarea>
  </mat-form-field>
</div>
}
</ng-container>
</div>
</div>
@if (ownershipWarning!==null) {
  <div class="ownership-warning">{{ownershipWarning}}</div>
}
<div mat-dialog-actions>
  <button mat-raised-button class="add-outlet-button" (click)="save()">Save</button>
  <button mat-raised-button (click)="close()">Close</button>
</div>
</ng-container>
